/*
 * Current reload
 */
export const FETCH_CURRENT_RELOAD_BEGIN = "FETCH_CURRENT_RELOAD_BEGIN";
export const FETCH_CURRENT_RELOAD_FAILURE = "FETCH_CURRENT_RELOAD_FAILURE";
export const FETCH_CURRENT_RELOAD_SUCCESS = "FETCH_CURRENT_RELOAD_SUCCESS";

/*
 * All reloads
 */
export const FETCH_ALL_RELOADS_BEGIN = "FETCH_ALL_RELOADS_BEGIN";
export const FETCH_ALL_RELOADS_FAILURE = "FETCH_ALL_RELOADS_FAILURE";
export const FETCH_ALL_RELOADS_SUCCESS = "FETCH_ALL_RELOADS_SUCCESS";

/*
 * Create reloads
 */
export const CREATE_RELOAD_BEGIN = "CREATE_RELOAD_BEGIN";
export const CREATE_RELOAD_FAILURE = "CREATE_RELOAD_FAILURE";
export const CREATE_RELOAD_SUCCESS = "CREATE_RELOAD_SUCCESS";



// WEBPACK FOOTER //
// ./src/constants/reloadActionsTypes.js